import React, { useState } from "react";
import styles from "../../styles/landing.module.css";

// Composant pour chaque question-réponse avec fonctionnalité d'expansion
const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className={`${styles.faqItem} ${isOpen ? styles.open : styles.closed}`}>
      <div className={styles.faqQuestion} onClick={() => setIsOpen(!isOpen)}>
        <h3>{question}</h3>
        <span className={styles.faqIcon}>{isOpen ? '−' : '+'}</span>
      </div>
      
      {isOpen && (
        <div className={styles.faqAnswer}>
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};

const FAQSection = ({ id }) => {
  // Liste des questions et réponses
  const faqItems = [
    {
      question: "How does Memory Curve work?",
      answer: "Memory Curve uses the spaced repetition algorithm based on Ebbinghaus' forgetting curve. The application automatically calculates the optimal times to review your information, just before you start to forget it."
    },
    {
      question: "What's the difference between the free and premium versions?",
      answer: "The free version allows you to manage up to 3 revision subjects with basic features. The premium version offers unlimited subjects, detailed statistics, Google Calendar integration, and a customizable algorithm."
    },
    {
      question: "Can I cancel my premium subscription at any time?",
      answer: "Yes, you can cancel your subscription at any time. You will continue to benefit from premium features until the end of your current billing period."
    },
    {
      question: "Does Memory Curve work on mobile?",
      answer: "Yes, Memory Curve is accessible from any web browser, on computer or mobile. A native app for iOS and Android is also in development."
    },
    {
      question: "Is my data secure?",
      answer: "We take the protection of your data very seriously. All data is encrypted and we never share your information with third parties without your explicit consent."
    }
  ];

  return (
    <section className={styles.faqSection} id={id}>
      <h2>Frequently Asked Questions</h2>
      
      <div className={styles.faqContainer}>
        {faqItems.map((item, index) => (
          <FAQItem 
            key={index} 
            question={item.question} 
            answer={item.answer} 
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection; 